// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-picker {
  display: flex;
  flex-direction: column;
}
.date-range-picker .date-range-content {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}
.date-range-picker .date-range-content .from {
  border-bottom: 1px solid var(--list-item-bordercolor);
  color: gray;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  width: 47%;
  margin-right: 3%;
}
.date-range-picker .date-range-content .from.required {
  border-bottom: 1px solid var(--elem-red-color);
  animation: vibra .09s 5 linear;
}
.date-range-picker .date-range-content .to {
  border-bottom: 1px solid var(--list-item-bordercolor);
  color: gray;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  width: 47%;
  margin-left: 3%;
}
.date-range-picker .date-range-content .to.required {
  border-bottom: 1px solid var(--elem-red-color);
  animation: vibra .09s 5 linear;
}
.date-range-picker .date-range-content .date-picker {
  display: flex;
  width: 100%;
  color: var(--custom-textarea-color);
}
.date-range-picker .date-range-content .date-picker .datepicker-from-placeholder {
  position: absolute;
  pointer-events: none;
  cursor: pointer;
  z-index: 999;
  display: flex;
  margin: 5px;
  transform: translateY(5px);
  color: #aaa;
  transition-property: all;
  transition-duration: .25s;
}
.date-range-picker .date-range-content .date-picker .datepicker-from-placeholder.required {
  color: var(--elem-red-color);
}
.date-range-picker .date-range-content .date-picker .datepicker-from-placeholder-up {
  color: #aaa;
  font-size: 0.8em;
  transition-property: all;
  transition-duration: .25s;
  transform: translateY(-12px);
}
.date-range-picker .date-range-content .date-picker .datepicker-to-placeholder {
  position: absolute;
  cursor: pointer;
  z-index: 999;
  display: flex;
  margin: 5px;
  transform: translateY(5px);
  color: #aaa;
  transition-property: all;
  transition-duration: .25s;
}
.date-range-picker .date-range-content .date-picker .datepicker-to-placeholder.required {
  color: var(--elem-red-color);
}
.date-range-picker .date-range-content .date-picker .datepicker-to-placeholder-up {
  color: #aaa;
  font-size: 0.8em;
  transition-property: all;
  transition-duration: .25s;
  transform: translateY(-12px);
}
.date-picker-input-from {
  border: none !important;
  outline: none;
  width: 95% !important;
  margin: 6px auto auto 5px;
  cursor: pointer;
  color: var(--custom-textarea-color);
  background-color: var(--bg-color);
  opacity: 0;
}
.date-picker-input-to {
  border: none;
  outline: none;
  width: 95%;
  margin: 6px auto auto 5px;
  cursor: pointer;
  color: var(--custom-textarea-color);
  background-color: var(--bg-color);
  opacity: 0;
}
.date-picker-input-to.required {
  color: var(--elem-red-color);
  border-bottom: 1px solid var(--elem-red-color);
  animation: vibra .09s 5 linear;
}
.mx-datepicker-popup {
  background-color: var(--bg-color);
  border: 1px solid var(--datepicker-border-color);
}
.mx-calendar-content .cell:hover:not(.actived) {
  background-color: var(--datepicker-cell-hover);
}
.visible {
  opacity: 1;
  transition-property: opacity;
  transition-duration: .5s;
}
.mx-datepicker {
  width: 100% !important;
  font-size: inherit;
  line-height: 1.8em;
  cursor: pointer;
}
.mx-input-append {
  transform: translateY(1px);
}
.mx-clear-icon::before {
  transform: translateY(-1px);
  display: inline-block;
  content: "\\f00d";
  font-weight: 100;
  vertical-align: middle;
  font-family: "Font Awesome 5 Pro";
}
@keyframes vibra {
50% {
    transform: translateX(-1px);
}
100% {
    transform: translateX(1px);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/settings/DateRangePicker.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,8BAA8B;AAChC;AACA;EACE,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mCAAmC;EACnC,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,mCAAmC;EACnC,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;AACA;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA","sourcesContent":[".date-range-picker {\n  display: flex;\n  flex-direction: column;\n}\n.date-range-picker .date-range-content {\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n}\n.date-range-picker .date-range-content .from {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  color: gray;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  width: 47%;\n  margin-right: 3%;\n}\n.date-range-picker .date-range-content .from.required {\n  border-bottom: 1px solid var(--elem-red-color);\n  animation: vibra .09s 5 linear;\n}\n.date-range-picker .date-range-content .to {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  color: gray;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  width: 47%;\n  margin-left: 3%;\n}\n.date-range-picker .date-range-content .to.required {\n  border-bottom: 1px solid var(--elem-red-color);\n  animation: vibra .09s 5 linear;\n}\n.date-range-picker .date-range-content .date-picker {\n  display: flex;\n  width: 100%;\n  color: var(--custom-textarea-color);\n}\n.date-range-picker .date-range-content .date-picker .datepicker-from-placeholder {\n  position: absolute;\n  pointer-events: none;\n  cursor: pointer;\n  z-index: 999;\n  display: flex;\n  margin: 5px;\n  transform: translateY(5px);\n  color: #aaa;\n  transition-property: all;\n  transition-duration: .25s;\n}\n.date-range-picker .date-range-content .date-picker .datepicker-from-placeholder.required {\n  color: var(--elem-red-color);\n}\n.date-range-picker .date-range-content .date-picker .datepicker-from-placeholder-up {\n  color: #aaa;\n  font-size: 0.8em;\n  transition-property: all;\n  transition-duration: .25s;\n  transform: translateY(-12px);\n}\n.date-range-picker .date-range-content .date-picker .datepicker-to-placeholder {\n  position: absolute;\n  cursor: pointer;\n  z-index: 999;\n  display: flex;\n  margin: 5px;\n  transform: translateY(5px);\n  color: #aaa;\n  transition-property: all;\n  transition-duration: .25s;\n}\n.date-range-picker .date-range-content .date-picker .datepicker-to-placeholder.required {\n  color: var(--elem-red-color);\n}\n.date-range-picker .date-range-content .date-picker .datepicker-to-placeholder-up {\n  color: #aaa;\n  font-size: 0.8em;\n  transition-property: all;\n  transition-duration: .25s;\n  transform: translateY(-12px);\n}\n.date-picker-input-from {\n  border: none !important;\n  outline: none;\n  width: 95% !important;\n  margin: 6px auto auto 5px;\n  cursor: pointer;\n  color: var(--custom-textarea-color);\n  background-color: var(--bg-color);\n  opacity: 0;\n}\n.date-picker-input-to {\n  border: none;\n  outline: none;\n  width: 95%;\n  margin: 6px auto auto 5px;\n  cursor: pointer;\n  color: var(--custom-textarea-color);\n  background-color: var(--bg-color);\n  opacity: 0;\n}\n.date-picker-input-to.required {\n  color: var(--elem-red-color);\n  border-bottom: 1px solid var(--elem-red-color);\n  animation: vibra .09s 5 linear;\n}\n.mx-datepicker-popup {\n  background-color: var(--bg-color);\n  border: 1px solid var(--datepicker-border-color);\n}\n.mx-calendar-content .cell:hover:not(.actived) {\n  background-color: var(--datepicker-cell-hover);\n}\n.visible {\n  opacity: 1;\n  transition-property: opacity;\n  transition-duration: .5s;\n}\n.mx-datepicker {\n  width: 100% !important;\n  font-size: inherit;\n  line-height: 1.8em;\n  cursor: pointer;\n}\n.mx-input-append {\n  transform: translateY(1px);\n}\n.mx-clear-icon::before {\n  transform: translateY(-1px);\n  display: inline-block;\n  content: \"\\f00d\";\n  font-weight: 100;\n  vertical-align: middle;\n  font-family: \"Font Awesome 5 Pro\";\n}\n@keyframes vibra {\n50% {\n    transform: translateX(-1px);\n}\n100% {\n    transform: translateX(1px);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
